<template>
    <div>
        <div class="header">
            <slot name="header">
                <h4 class="title">{{title}}</h4>
                <p class="category">{{subTitle}}</p>
            </slot>
        </div>
        <div class="content table-responsive table-full-width" id="table">
            <table :id="id" class="table" :class="tableClass">
                <thead class="text-right">
                <tr>
                    <th v-if="dayDisplay">Dzień</th>
                    <th class="text-right">PIT28</th>
                    <th class="text-right">PIT36</th>
                    <th class="text-right">PIT36l</th>
                    <th class="text-right">PIT37</th>
                    <th class="text-right">PIT38</th>
                    <th class="text-right">PIT39</th>
                    <th class="text-right">Suma</th>
                </tr>
                </thead>
                <tbody class="text-center">
                <tr v-for="(item, index) in data">
                    <td v-if="dayDisplay"> {{item.day}}</td>
                    <td class="text-right" v-for="declarationValue in item[dataType]" >
                        {{dataType == "fills" ? declarationValue : numberFormatter(declarationValue)}}
                    </td>
                    <td class="text-right">{{dataType == "fills" ? sumRows[index] : numberFormatter(sumRows[index])
                        }}
                    </td>
                </tr>
                <tr class="text-right">
                    <td class="text-center">Suma</td>
                    <td>{{dataType == 'fills' ? numberFormatterThousand(sum.pit28) : numberFormatter(sum.pit28)}}</td>
                    <td>{{dataType == 'fills' ? numberFormatterThousand(sum.pit36) : numberFormatter(sum.pit36)}}</td>
                    <td>{{dataType == 'fills' ? numberFormatterThousand(sum.pit36l) : numberFormatter(sum.pit36l)}}</td>
                    <td>{{dataType == 'fills' ? numberFormatterThousand(sum.pit37) : numberFormatter(sum.pit37)}}</td>
                    <td>{{dataType == 'fills' ? numberFormatterThousand(sum.pit38) : numberFormatter(sum.pit38)}}</td>
                    <td>{{dataType == 'fills' ? numberFormatterThousand(sum.pit39) : numberFormatter(sum.pit39)}}</td>
                    <td class="text-right">{{dataType == 'fills' ? numberFormatterThousand(sum.summary) : numberFormatter(sum.summary)}}
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
  export default {
    data () {
      return {}
    },
    mounted () {
    },
    props: {
      id: '',
      dayDisplay: '',
      columns: Array,
      data: Array,
      dataType: '',
      type: {
        type: String, // striped | hover
        default: 'striped'
      },
      title: {
        type: String,
        default: ''
      },
      subTitle: {
        type: String,
        default: ''
      },
      columnsNames: Array,
      sumRows: Array,
      sum: Object
    },
    watch: {
      data () {}
    },
    computed: {
      tableClass () {
        return `table-${this.type}`
      }
    },
    methods: {
      hasValue (item, column) {
        return item[column.toLowerCase()] !== 'undefined'
      },
      itemValue (item, column) {
        return item[column.toLowerCase()]
      }
    }
  }
</script>
<style>
    #table > .table-striped > tbody > tr > td {
        padding: 3px;
    }
</style>



// WEBPACK FOOTER //
// DeclarationsTable.vue?9c38e782